module.exports = __webpack_public_path__ + "static/media/people_notif.a38643fc.svg";